export default "__VITE_ASSET__Cfxv_AGf__"